<template>
    <div class="row gutter-sm">
        <div class="col-xs-12 col-sm-2">
            <div class="content" @click="handleFileChange">
                <div class="content-overlay"></div>
                <img class="content-image" :src="getPlaceholder" v-if="user_image == null" :key="cod">
                <img class="content-image" :src="user_image" v-if="user_image" @error="errorImage" :key="cod">

                <div class="content-details fadeIn-top">
                    <p>{{ $t('change_image') }}</p>
                </div>
            </div>

            <input type="file" ref="file" style="display:none" accept=".gif,.jpg,.jpeg,.png" v-uploader />

            <uploader :file="file" :aspect_ratio="1/1" :aspect_ratio_string="'1/1'" style="display:none" @fileUploaded="fileUploaded" @uploadStarted="uploadStarted" />
        </div>

        <div class="col-xs-12 col-sm-10">
            <div class="row gutter-md q-mb-md">
                    <div class="col-12 text-h6" :class="$q.platform.is.mobile ? 'text-white' : ''">
                        {{ $t('personal_information') }}
                    </div>

                <div class="col-12 col-sm-6" v-if="user_profile.full_name">
                    <q-input v-model="full_name" :float-label="$t('name')" :error="$v.full_name.$error" @input="$v.full_name.$touch" :disable="user_profile.full_name_disabled" />
                </div>

                <div class="col-xs-12 col-sm-6" v-if="user_profile.nickname">
                    <q-input v-model="nickname" :float-label="$t('nick_name')" :error="$v.nickname.$error" @input="$v.nickname.$touch" :disable="user_profile.nickname_disabled" />
                </div>

                <div class="col-12 col-sm-6" v-if="user_profile.email">
                    <q-field :error="$v.email.$error" :error-label="$t(email_error_message)">
                        <q-input v-model="email" :float-label="$t('email')" type="email" :error="$v.email.$error" @input="$v.email.$touch" @blur="emailUnique()" :disable="user_profile.email_disabled" />
                    </q-field>
                </div>

                <div class="col-xs-12 col-sm-6" v-if="user_profile.document">
                    <q-field :error="document_error" :error-label="document_error ? $t('document_not_unique') : ''">
                        <q-input v-model="document" :float-label="`${$t(documentIsCPF)}`"  :error="$v.document.$error" @input="$v.document.$touch" @blur="documentUnique()" :disable="user_profile.document_disabled" />
                    </q-field>
                </div>

                <div class="col-xs-12 col-sm-6" v-if="user_profile.birthday">
                    <q-datetime v-model="birthday" :float-label="$t('birthday')" format="DD/MM" type="date" :error="$v.birthday.$error" @input="$v.birthday.$touch" :disable="user_profile.birthday_disabled" format-model="date" />
                </div>

                <div class="col-xs-12 col-sm-6" v-if="user_profile.gender">
                    <q-select v-model="gender" :options="getUserGenders" :float-label="$t('gender')" :error="$v.gender.$error" @input="$v.gender.$touch" :disable="user_profile.gender_disabled" />
                </div>
            </div>
        </div>

        <div class="col-xs-12 col-sm-6" v-if="user_profile.marital_status">
            <q-select v-model="marital_status" :options="marital_statuses" :float-label="$t('marital')" clearable  :error="$v.marital_status.$error" @input="$v.marital_status.$touch" :disable="user_profile.marital_status_disabled" />
        </div>

        <div class="col-xs-12 col-sm-6" v-if="user_profile.number_of_children">
            <q-input v-model="number_of_children" type="number" :float-label="$t('number_of_children')" :error="$v.number_of_children.$error" @input="$v.number_of_children.$touch" :disable="user_profile.number_of_children_disabled" />
        </div>

        <div class="col-xs-12 col-sm-6" v-if="user_profile.register">
            <q-field :error="register_error" :error-label="register_error ? $t('register_not_unique') : ''">
                <q-input v-model="register" :float-label="$t('register')" :error="$v.register.$error" @input="$v.register.$touch" @blur="registerUnique()" :disable="user_profile.register_disabled || isChevrolet" />
            </q-field>
        </div>

        <div class="col-12" v-if="isChevrolet && user_profile.register_2">
            <q-field :error="register_2_error" :error-label="register_2_error ? $t('gmin_number_not_unique') : ''">
                <q-input v-model="register_2" :float-label="$t('gmin_number')" :error="$v.register_2.$error" @input="$v.register_2.$touch" :disable="user_profile.register_2_disabled" @blur="register2Unique()"  />
            </q-field>
        </div>

        <div class="col-xs-12 col-sm-6" v-if="user_profile.is_handicapped">
            <q-select v-model="is_handicapped" :options="[{ value: true, label: $t('yes') }, { value: false, label: $t('no') }]" :float-label="$t('is_handicapped')" :disable="user_profile.is_handicapped_disabled" />
        </div>

        <div class="col-xs-12 col-sm-6" v-if="user_profile.handicap_description">
            <q-input v-model="handicap_description" :float-label="$t('handicap_description')" :error="$v.handicap_description.$error" @input="$v.handicap_description.$touch" :disable="user_profile.handicap_description_disabled || !is_handicapped" />
        </div>

        <div class="row gutter-sm col-12 q-mb-md">
            <div class="col-12 text-h6" :class="$q.platform.is.mobile ? 'text-white' : ''">
                {{ $t('contact_information') }}
            </div>

            <div class="col-xs-12 col-sm-6 col-lg-3" v-if="user_profile.mobile_phone">
                <q-input v-model="phone_mobile.phone" :float-label="$t('mobile')" :error="$v.phone_mobile.phone.$error" @input="$v.phone_mobile.phone.$touch" :disable="user_profile.mobile_phone_disabled" />
            </div>

            <div class="col-xs-12 col-sm-6 col-lg-3" v-if="user_profile.whatsapp_phone">
                <q-input v-model="phone_whatsapp.phone" :float-label="$t('whatsapp')" :error="$v.phone_whatsapp.phone.$error" @input="$v.phone_whatsapp.phone.$touch" :disable="user_profile.whatsapp_phone_disabled" />
            </div>

            <div class="col-xs-12 col-sm-6 col-lg-3" v-if="user_profile.commercial_phone">
                <q-input v-model="phone_commercial.phone" :float-label="$t('commercial')" :error="$v.phone_commercial.phone.$error" @input="$v.phone_commercial.phone.$touch" :disable="user_profile.commercial_phone_disabled" />
            </div>

            <div class="col-xs-12 col-sm-6 col-lg-3" v-if="user_profile.home_phone">
                <q-input v-model="phone_residential.phone" :float-label="$t('residential')" :error="$v.phone_residential.phone.$error" @input="$v.phone_residential.phone.$touch" :disable="user_profile.home_phone_disabled" />
            </div>
        </div>

        <div class="row gutter-sm q-mb-md" v-if="user_profile.address">
            <div>
                <div v-if="$q.platform.is.mobile" class="col-12 text-h6 text-white">
                    {{ $t('address') }}
                </div>

                <div v-else class="col-12 text-h6">
                    {{ $t('address') }}
                </div>
            </div>

            <div v-if="keyGooogleMaps && user_profile.address" class="col-xs-12 col-sm-12">
                <q-field :error="show_maps_alert" :error-label="$t('not_found_check_that_the_search_is_spelled_correctly_Try_adding_a_city_state_or_zip_code')">
                    <q-input v-model="address" :float-label="$t('address')" autocomplete="new-password" :error="$v.address.$error" @input="$v.address.$touch" :disable="user_profile.address_disabled" :placeholder="$t('search_by_name_and_street_number')">
                        <q-autocomplete
                            @search="getAddressGoogleMaps"
                            :min-characters="3"
                            @selected="selectedAddressGoogleMaps"
                            separator
                        />
                    </q-input>
                </q-field>
            </div>

            <div v-else class="col-xs-12 col-sm-12">
                <q-input v-model="address" :float-label="$t('address')" autocomplete="new-password" :error="$v.address.$error" @input="$v.address.$touch" :disable="user_profile.address_disabled">
                    <q-autocomplete
                        @search="getAddress"
                        :min-characters="3"
                        @selected="selectedAddress"
                        separator
                    />
                </q-input>
            </div>

            <div class="col-xs-12 col-sm-4">
                <q-input v-model="number" :float-label="$t('number')" ref="number" :disable="user_profile.address_disabled" />
            </div>

            <div class="col-xs-12 col-sm-4">
                <q-input v-model="neighborhood" :float-label="$t('neighborhood')" :disable="user_profile.address_disabled" />
            </div>

            <div class="col-xs-12 col-sm-4">
                <q-input v-model="complement" :float-label="$t('complement')" :disable="user_profile.address_disabled" />
            </div>

            <div class="col-xs-12 col-sm-4">
                <q-input v-model="postal_code" :float-label="$t('postal_code')" :disable="user_profile.address_disabled" />
            </div>

            <div class="col-xs-12 col-sm-4">
                <q-input v-model="country" :float-label="$t('country')" :error="$v.country.$error" @input="$v.country.$touch" :disable="user_profile.address_disabled" />
            </div>

            <div class="col-xs-12 col-sm-4">
                <q-input v-model="city" :float-label="$t('city')" :error="$v.city.$error" @input="$v.city.$touch" :disable="user_profile.address_disabled"/>
            </div>

            <div class="col-xs-12 col-sm-4">
                <q-input v-model="state" :float-label="$t('state')" :disable="user_profile.address_disabled" />
            </div>
        </div>

        <div class="col-xs-12 col-sm-6" v-if="user_profile.user_type">
            <q-select v-model="user_type" :options="getUserTypes" :float-label="$t('user_type')" :error="$v.user_type.$error" @input="$v.user_type.$touch" :disable="user_profile.user_type_disabled" />
        </div>

        <div class="col-12">
            <div class="row gutter-sm justify-end q-mt-sm q-mb-md" >
                <div class="col-xs-12 col-sm-3" v-if="!getIsDisabled">
                    <q-btn color="secondary" class="full-width" :label="$t('save')" icon="far fa-save" @click="saveData()" />
                </div>
            </div>
        </div>

        <q-dialog v-model="select_source">
            <span slot="title">{{ $t('select_source') }}</span>

            <span slot="message">{{ $t('select_the_image_source') }}</span>

            <template slot="buttons" slot-scope="props">
                <q-btn color="primary" :label="$t('galery')" icon="fal fa-images" @click="setSource('galery')" />
                <q-btn color="secondary" :label="$t('camera')" icon="fal fa-camera-alt" @click="setSource('camera')" />
            </template>
        </q-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { date, uid } from 'quasar'
import { required, requiredIf, email } from 'vuelidate/lib/validators'
import { OpenStreetMapProvider } from 'leaflet-geosearch'
import Uploader from 'components/Uploader'
import * as moment from 'moment'
import * as tz from 'moment-timezone'

const provider = new OpenStreetMapProvider({
    params: {
        addressdetails: '1'
    }
})
const { formatDate } = date

export default {
    data() {
        return {
            address: '',
            address_id: '',
            birthday: '',
            city: '',
            cod: null,
            complement: '',
            country: '',
            document: '',
            document_error: false,
            email: '',
            email_error: false,
            email_error_message: '',
            file: '',
            full_name: '',
            gender: '',
            handicap_description: '',
            is_handicapped: false,
            lat: '',
            long: '',
            marital_status: '',
            neighborhood: '',
            nickname: '',
            number: '',
            number_of_children: '',
            phone_commercial: {},
            phone_mobile: {},
            phone_residential: {},
            phone_whatsapp: {},
            postal_code: '',
            register: '',
            register_2: '',
            register_2_error: false,
            register_error: false,
            select_source: false,
            state: '',
            user_image: '',
            user_type: null
        }
    },

    components: {
        'uploader': Uploader
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            id: 'common/id',
            clients: 'params/clients',
            marital_statuses: 'registration_lists/marital_status',
            genders: 'registration_lists/genders',
            phone_types: 'registration_lists/phone_types',
            id_user_client_selected: 'common/id_user_client_selected',
            id_user_language_selected: 'common/id_user_language_selected',
            user_profile: 'params/user_profile',
            user_types: 'registration_lists/user_types'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getUserGenders() {
            if (this.genders) {
                return this.genders.map(gender => {
                    return {
                        ...gender,
                        "label": this.$t(gender.label)
                    }
                })
            }
        },

        getUserTypes() {
            if (this.user_types) {
                return this.user_types.map(type => {
                    return {
                        ...type,
                        label: this.$t(type.label)
                    }
                })
            }
        },

        getPlaceholder() {
            let client = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })

			if (client) {
                return client.user_avatar_placeholder
            }
			else return ''
        },

        getIsDisabled() {
            let client = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })

			if (client) {
                return client.block_profile_site_edit
            }
			else return false
        },

        keyGooogleMaps() {
            return process.env.KEY_GOOGLE_API
        },

        isChevrolet() {
            if (process.env.PROJECT_FOLDER === 'universidadechevrolet') return true
            return false
        },

        documentIsCPF() {
            if (process.env.PROJECT_FOLDER === 'universidadechevrolet' && this.id_user_client_country_selected === 32 && this.id_user_language_selected == 1) return "cpf"
            else if ((process.env.PROJECT_FOLDER === 'siemens' || process.env.PROJECT_FOLDER === 'academiacoral') && this.id_user_language_selected == 1) return 'document_cpf'
            return 'document'
        },
    },

    methods: {
        fetchData() {
            this.$axios.get(`/etraining_profile/my_profile/`, this.getHeader)
            .then(response => {
                this.$q.loading.hide()

                this.full_name = response.data.full_name
                this.nickname = response.data.nick_name
                this.birthday = response.data.user_data.birthday ? moment(response.data.user_data.birthday).tz('Etc/GMT').format('YYYY-MM-DDTHH:mm:ss.SSS') : null
                this.document = response.data.user_data.document

                this.register = response.data.user_data.register
                this.marital_status = response.data.user_data.marital_status
                this.number_of_children = response.data.user_data.number_of_children

                this.email = response.data.email
                this.gender = response.data.user_data.gender
                this.register = response.data.user_data.register

                this.user_image = response.data.user_image

                this.is_handicapped = response.data.user_data.is_handicapped
                this.handicap_description = response.data.user_data.handicap_description
                this.register_2 = response.data.user_data.register_2

                response.data.user_data.addresses.forEach(address => {
                    this.address_id = address.id
                    this.address = address.address
                    this.postal_code = address.postal_code
                    this.city = address.city
                    this.state = address.state
                    this.lat = address.lat
                    this.long = address.long
                    this.neighborhood = address.neighborhood
                    this.number = address.number
                    this.complement = address.complement
                    this.country = address.country
                })

                response.data.user_data.phones.forEach(phone => {
                    switch(phone.phone_type) {
                        case 3: this.phone_mobile = {...phone}
                        break
                        case 1: this.phone_commercial = {...phone}
                        break
                        case 2: this.phone_residential = {...phone}
                        break
                        case 4: this.phone_whatsapp = {...phone}
                        break
                    }
                })
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        saveData() {
            this.$v.$touch()

            if (!this.$v.$error) {
                this.$q.loading.show()

                let phones = []
                let user_data = []

                let addresses = [{
                    id: this.address_id,
                    address: this.address,
                    city: this.city,
                    complement: this.complement,
                    neighborhood: this.neighborhood,
                    number: this.number,
                    postal_code: this.postal_code,
                    state: this.state,
                    country: this.country
                }]

                if(this.lat != "" || this.lat != null) addresses.lat = this.lat
                if(this.long != "" || this.long != null) addresses.long = this.long

                if (this.phone_mobile.phone) {
                    phones.push({...this.phone_mobile, phone_type: 3, area_code: '', country_code: ''})
                }
                if (this.phone_residential.phone) {
                    phones.push({...this.phone_residential, phone_type: 2, area_code: '', country_code: ''})
                }
                if (this.phone_commercial.phone) {
                    phones.push({...this.phone_commercial, phone_type: 1, area_code: '', country_code: ''})
                }
                if (this.phone_whatsapp.phone) {
                    phones.push({...this.phone_whatsapp, phone_type: 4, area_code: '', country_code: ''})
                }

                user_data = {
                    addresses: addresses,
                    birthday: date.formatDate(this.birthday, 'YYYY-MM-DD'),
                    document: this.document,
                    gender: this.gender,
                    marital_status: this.marital_status,
                    number_of_children: this.number_of_children,
                    handicap_description: this.handicap_description,
                    is_handicapped: this.is_handicapped,
                    phones: phones,
                    register: this.register,
                    register_2: this.register_2
                }

                let data = {
                    email: this.email,
                    full_name: this.full_name,
                    nick_name: this.nickname,
                    user_data: user_data
                }

                if(!data) {
                    this.$q.notify({
                        message: this.$t('make_sure_that_all_fields_are_filled_in'),
                        type: 'negative',
                        icon: 'fal fa-exclamation-triangle',
                        position: 'top'
                    })
                }

                this.$axios.put(`/etraining_profile/my_profile/change_user_data/`, data, this.getHeader)
                .then(response => {
                    this.$q.loading.hide()

                    this.$q.notify({
                        message: this.$t('profile_edit_success'),
                        type: 'positive',
                        icon: 'fal fa-save'
                    })
                })
                .catch(e => {
                    this.$q.notify({
                        message: this.$t('unexpected_error_try_again_later'),
                        type: 'negative',
                        icon: 'fal fa-exclamation-triangle',
                        position: 'top'
                    })
                    this.$q.loading.hide()
                    console.log(e)
                })
            }
            else {
                this.$q.notify({
                    message: this.$t('make_sure_that_all_fields_are_filled_in'),
                    type: 'negative',
                    icon: 'fal fa-exclamation-triangle',
                    position: 'top'
                })
            }
        },

        fetchLists() {
            this.$q.loading.show()
            this.$axios.get('/accounts/get_site_registration_lists/', this.getHeader)
            .then(response => {

                this.$store.dispatch('registration_lists/SET_LISTS', [response.data])
                this.fetchData()
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        getAddress(terms, done) {
            provider.search({ query: terms })
            .then((result) => {
                done(result)
            })
        },

        selectedAddress(item) {
            this.$nextTick(() => this.address = item.raw.address.road)

            this.postal_code = item.raw.address.postcode
            this.city = item.raw.address.city
            this.state = item.raw.address.state
            this.lat = item.raw.lat
            this.long = item.raw.lon
            this.country = item.raw.address.country

            if (item.raw.address.neighbourhood) {
                this.neighborhood = item.raw.address.neighbourhood
            }
            else if (item.raw.address.suburb) {
                this.neighborhood = item.raw.address.suburb
            }
            else if (item.raw.address.city_district) {
                this.neighborhood = item.raw.address.city_district
            }
        },

        getAddressGoogleMaps(terms,done){
            this.$axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${terms}&key=${this.keyGooogleMaps}`)
            .then(response => {
                if(response.data.results.length > 0){
                    this.option_address = response.data.results
                    let teste = response.data.results.map(e => ({label: e.formatted_address, value: e.formatted_address, place_id: e.place_id}))
                    done(teste)
                }else{
                    this.show_maps_alert = true
                }
            })
            .catch(e => {
                console.log(e)
            })
        },

        selectedAddressGoogleMaps(item) {
            this.show_maps_alert = false

            this.address = ''
            this.postal_code = ''
            this.city = ''
            this.state = ''
            this.lat = ''
            this.long = ''
            this.country = ''
            this.neighborhood = ''
            this.number = ''

            this.option_address.map (x =>{
                if(x.place_id === item.place_id) {
                    this.lat = x.geometry.location.lat
                    this.long = x.geometry.location.lng
                    x.address_components.map(e => {
                        switch(e.types[0]) {
                        case 'route':
                            this.address = e.long_name
                            break;
                        case 'political':
                        case 'administrative_area_level_4':
                            this.neighborhood = e.long_name
                            break;
                        case 'street_number':
                            this.number = e.long_name
                            break;
                        case 'postal_code':
                            this.postal_code = e.long_name
                            break;
                        case 'administrative_area_level_2':
                            this.city = e.long_name
                            break;
                        case 'country':
                            this.country = e.long_name
                            break;
                        case 'administrative_area_level_1':
                            this.state = e.long_name
                            break;
                        }
                    })
                }
            })
        },

        documentUnique() {
            if (this.document) {
                let fd = new FormData()
                fd.append('document', this.document)
                fd.append('id_user', this.id)

                this.$axios.post(`/admin_users/users/check_document_existance/`, fd, this.getHeader)
                .then(response => {
                    if (response.data.exists) this.document_error = true
                    else this.document_error = false
                })
                .catch(e => {
                    console.log(e)
                })
            }
            else this.document_error = false
        },

        registerUnique() {
            if (this.register) {
                let fd = new FormData()
                fd.append('register', this.register)
                fd.append('id_user', this.id)

                this.$axios.post(`/admin_users/users/check_register_existance/`, fd, this.getHeader)
                .then(response => {
                    if (response.data.exists) this.register_error = true
                    else this.register_error = false
                })
                .catch(e => {
                    console.log(e)
                })
            }
            else this.register_error = false
        },

        register2Unique() {
            if (this.register_2) {
                let fd = new FormData()
                fd.append('register_2', this.register_2)
                fd.append('id_user', this.id)

                this.$axios.post(`/admin_users/users/check_register_2_existance/`, fd, this.getHeader)
                .then(response => {
                    if (response.data.exists) this.register_2_error = true
                    else this.register_2_error = false
                })
                .catch(e => {
                    console.log(e)
                })
            }
            else this.register_2_error = false
        },

        emailUnique() {
            if (this.email) {
                let fd = new FormData()
                fd.append('email', this.email)
                fd.append('id_user', this.id)

                this.$axios.post(`/admin_users/users/check_email_existance/`, fd, this.getHeader)
                .then(response => {
                    if (response.data.exists) {
                        this.email_error = true
                        this.email_error_message = 'email_already_in_use'
                    }
                    else {
                        this.email_error = false
                        this.email_error_message = ''
                    }
                })
                .catch(e => {
                    console.log(e)
                })
            }
            else {
                this.email_error = false
                this.email_error_message = ''
            }
        },

        handleFileChange() {
            if (this.$q.platform.is.cordova) {
                this.select_source = true
            }
            else {
                this.$refs.file.click()
            }
        },

        setSource(source) {
            this.select_source = false
            this.selectedMobileSource(source)
        },

        selectedMobileSource(souce) {
            let options = {
                quality: 50,
                destinationType: Camera.DestinationType.DATA_URL,
                encodingType: Camera.EncodingType.JPEG,
                mediaType: Camera.MediaType.PICTURE,
                targetWidth: 720,
                correctOrientation: true
            }

            if (souce === 'galery') options.sourceType = Camera.PictureSourceType.PHOTOLIBRARY

            navigator.camera.getPicture((imageData) => {
                this.file = this.getBlob(imageData)
            }, (message) => {
                console.log(message)
            }, options)
        },

        uploadStarted() {
            this.$q.loading.show()
        },

        fileUploaded(url) {
            this.$q.loading.show()
            this.file = ''

            let fd = new FormData()
            fd.append('image', url)

            this.$axios.put(`/etraining_profile/my_profile/change_user_image/`, fd, this.getHeader)
            .then(response => {
                this.user_image = response.data.user_image
                this.cod = uid()

                this.$q.notify({
                    message: this.$t('profile_edit_success'),
                    type: 'positive',
                    icon: 'fal fa-save'
                })
                this.$q.loading.hide()
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        errorImage() {
            this.user_image = ''
        },

        formatDate(val, format) {
            return date.formatDate(val, format)
        },

        getBlob(b64Data, contentType, sliceSize) {
            contentType = contentType || '';
            sliceSize = sliceSize || 512;

            let byteCharacters = atob(b64Data);
            let byteArrays = [];

            for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                let slice = byteCharacters.slice(offset, offset + sliceSize);

                let byteNumbers = new Array(slice.length);
                for (let i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                let byteArray = new Uint8Array(byteNumbers);

                byteArrays.push(byteArray);
            }

            let blob = new Blob(byteArrays, {type: contentType});
            return blob
        }
    },

    directives: {
        uploader: {
            bind(el, binding, vnode){
                el.addEventListener('change', e => {
                    if (e.target.files[0] !== undefined) {
                        vnode.context.file = e.target.files[0]
                    }
                })
            }
        }
    },

    watch: {
        file() {
            this.$emit('file-chosen', this.file)
        },
        id_user_language_selected: function() {
		    this.fetchLists()
        }
    },

    created() {
        this.fetchLists()
    },

    validations() {
        return {
            full_name: {
                requiredIf: requiredIf(() => {
                    return this.user_profile.full_name_required
                })
            },
            email: {
                requiredIf: requiredIf(() => {
                    return this.user_profile.email_required
                }),
                email,
                emailUnique() {
                    if (!this.email_error) return true
                    else return false
                }
            },
            birthday: {
                requiredIf: requiredIf(() => {
                    return this.user_profile.birthday_required
                })
            },
            gender: {
                requiredIf: requiredIf(() => {
                    return this.user_profile.gender_required
                })
            },
            document: {
                requiredIf: requiredIf(() => {
                    return this.user_profile.document_required
                }),
                documentUnique() {
                    if (!this.document_error) return true
                    else return false
                }
            },
            register: {
                requiredIf: requiredIf(() => {
                    return this.user_profile.register_required
                }),
                registerUnique() {
                    if (!this.register_error) return true
                    else return false
                }
            },
            register_2: {
                requiredIf: requiredIf(() => {
                    return this.user_profile.register_2_required
                })
            },
            address: {
                requiredIf: requiredIf(() => {
                    return this.user_profile.address_required
                })
            },
            country: {
                requiredIf: requiredIf(() => {
                    return this.user_profile.address_required
                })
            },
            city: {
                requiredIf: requiredIf(() => {
                    return this.user_profile.address_required
                })
            },
            state: {
                requiredIf: requiredIf(() => {
                    return this.user_profile.address_required
                })
            },
            nickname: {
                requiredIf: requiredIf(() => {
                    return this.user_profile.nickname_required
                })
            },
            number_of_children: {
                requiredIf: requiredIf(() => {
                    return this.user_profile.number_of_children_required
                })
            },
            marital_status: {
                requiredIf: requiredIf(() => {
                    return this.user_profile.marital_status_required
                })
            },
            is_handicapped: {
                requiredIf: requiredIf(() => {
                    return this.user_profile.is_handicapped_required
                }),
            },
            handicap_description: {
                requiredIf: requiredIf(() => {
                    return this.user_profile.handicap_description_required && this.is_handicapped
                }),
            },
            phone_mobile: {
                phone: {
                    requiredIf: requiredIf(() => {
                        return this.user_profile.mobile_phone_required
                    }),
                }
            },
            phone_residential: {
                phone: {
                    requiredIf: requiredIf(() => {
                        return this.user_profile.home_phone_required
                    }),
                }
            },
            phone_commercial: {
                phone: {
                    requiredIf: requiredIf(() => {
                        return this.user_profile.commercial_phone_required
                    }),
                }
            },
            phone_whatsapp: {
                phone: {
                    requiredIf: requiredIf(() => {
                        return this.user_profile.whatsapp_phone_required
                    }),
                }
            },
            user_type: {
                requiredIf: requiredIf(() => {
                    return this.user_profile.user_type_required
                })
            },
        }
    }
}
</script>

<style lang="stylus" scoped>
.content-image
    width 100%

.content-details
    position absolute
    text-align center
    padding-left 1em
    padding-right 1em
    width 100%
    top 50%
    left 50%
    opacity 0
    -webkit-transform translate(-50%, -50%)
    -moz-transform translate(-50%, -50%)
    transform translate(-50%, -50%)
    -webkit-transition all 0.3s ease-in-out 0s
    -moz-transition all 0.3s ease-in-out 0s
    transition all 0.3s ease-in-out 0s
    & p
        color #fff
        font-size 1.5rem

.content
    &:hover
        & .content-details
            top 50%
            left 50%
            opacity 1

.content
    position relative
    width 90%
    margin auto
    overflow hidden
    & .content-overlay
        background rgba(0,0,0,0.7)
        position absolute
        height 99%
        width 100%
        left 0
        top 0
        bottom 0
        right 0
        opacity 0
        -webkit-transition all 0.4s ease-in-out 0s
        -moz-transition all 0.4s ease-in-out 0s
        transition all 0.4s ease-in-out 0s
    &:hover
        cursor pointer
        & .content-overlay
            opacity 1

.fadeIn-top
    top 20%
</style>
